import React from 'react';
import {
    ActionDatePicker,
    ActionRadio,
    ActionRatio,
    ActionResult,
    QualityCheckRow,
} from '~/components/Patient';
import { enumValue } from '~/util';
import { FormikValues } from 'formik';

interface QualityDetailRowProps {
    detail: QualityMeasureDetailType;
    submissionAnswer?: SubmissionAnswerType;
    checkboxId: string;
    formik: FormikValues;
    readOnly: boolean;
}
export function QualityDetailRow({
    detail,
    submissionAnswer,
    checkboxId,
    readOnly,
    formik,
}: QualityDetailRowProps) {
    function getInputName(dt: QualityMeasureDetailType) {
        if (dt.data_type === enumValue(['gap', 'supplemental_value_data_types', 'NoValue']))
            return null;
        return `quality_measure_detail_${dt.id}_${dt.system_id}_${dt.data_type || 0}_answer`;
    }
    function showResultsField() {
        if (detail.data_type === enumValue(['gap', 'supplemental_value_data_types', 'NoValue']))
            return null;
        if (detail.lookup_metadata?.length) {
            return (
                <ActionRadio
                    detail={detail}
                    getName={getInputName}
                    gapCollection={[detail]}
                    readOnly={readOnly}
                    checkboxId={checkboxId}
                    formik={formik}
                />
            );
        }
        if (detail.data_type === enumValue(['gap', 'supplemental_value_data_types', 'Ratio'])) {
            return (
                <ActionRatio
                    detail={detail}
                    getName={getInputName}
                    readOnly={readOnly}
                    checkboxId={checkboxId}
                    formik={formik}
                />
            );
        }
        return (
            <ActionResult
                detail={detail}
                getName={getInputName}
                gapCollection={[detail]}
                readOnly={readOnly}
                checkboxId={checkboxId}
                formik={formik}
            />
        );
    }

    return (
        <>
            <QualityCheckRow
                detail={detail}
                readOnly={readOnly}
                checkboxId={checkboxId}
                formik={formik}
            />
            {formik.values[checkboxId] && (
                <tr className="quality-gap-action-row">
                    <td colSpan={4}>
                        <table className="quality-gap-results-table">
                            <thead>
                                <tr>
                                    <th className="checkbox-col">
                                        <span className="sr-only">Checkbox column</span>
                                    </th>
                                    <th className="w-30">Date</th>
                                    <th>
                                        {detail.data_type !==
                                        enumValue([
                                            'gap',
                                            'supplemental_value_data_types',
                                            'NoValue',
                                        ]) ? (
                                            'Results'
                                        ) : (
                                            <span className="sr-only">Empty column</span>
                                        )}
                                    </th>
                                    <th className="w-15">
                                        <span className="sr-only">Empty column</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="checkbox-col" aria-label="Checkbox" />
                                    <td className="w-30" aria-label="Date Selector">
                                        <ActionDatePicker
                                            detail={detail}
                                            submissionAnswer={submissionAnswer}
                                            name={`quality_measure_detail_${detail.id}_${
                                                detail.system_id
                                            }_${detail.data_type || 0}_date`}
                                            readOnly={readOnly}
                                            checkboxId={checkboxId}
                                            inputName={getInputName(detail)!}
                                            formik={formik}
                                        />
                                    </td>
                                    <td>{showResultsField()}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            )}
        </>
    );
}
